export default __webpack_public_path__ + "static/img9@2x-60381f53a4e17b4037bc7cdcb1c3f4d8.jpg";